/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsProformaProjectFormsType from '@jira/spa-apps__project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsProformaProjectForms: LazyComponent<
	() => React.JSX.Element | null
> = lazyForPaint<typeof ProjectSettingsProformaProjectFormsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-proforma-project-forms", jiraSpaEntry: "async-project-settings-proforma-project-forms" */ '@jira/spa-apps__project-settings-proforma-project-forms/src/ProformaProjectFormsSettingsPage.tsx'
		),
);

const AsyncProjectSettingsProformaProjectForms = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsProformaProjectForms}
		pageId="project-settings-proforma-project-forms"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsProformaProjectForms;
